import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid } from '@mui/material';

import { useFetchInitParametrosSistema } from './hooks'
import { ParametrosSistemaTable } from './ParametrosSistemaTable'
import { ParametrosSistemaForm } from './ParametrosSistemaForm'

export const ParametrosSistema = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitParametrosSistema({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        // FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

        // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    // const { fetchAllClients } = FetchData
    // const { loadingFetchAllClients } = fetchAllClients
    // ------------------------------------------------ Actions
    const { handleClickShowForm } = Actions

    return (
        <AllowedAccess permissions={['254_PARAMETROS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Parámetros del Sistema</div>
                                            <div className="border-bottom border-dark"></div>
                                            {/* {loadingFetchAllClients && ( <LinearLoading /> )} */}

                                            <div className="pt-4"></div>
                                            <ParametrosSistemaTable useFetchInit={useFetchInit} />
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            <ParametrosSistemaForm useFetchInit={useFetchInit} />
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )
}
